import { Convention } from "../../../../concepts/objects";
import { Point } from "../../../../platform/geom/Point";
import { FrameAddon } from "../FrameAddon";

export interface FrameAddonWithDimensions extends FrameAddon {

    dimensions: [number, number];

    getCorrectedSize(w: number, h: number): Point;

    offsetDimensions(cc: number, rc: number): void;
}

export const FrameAddonWithDimensions = new Convention<FrameAddonWithDimensions>('FrameAddonWithDimensions');